import { createAsyncTypes } from 'utils/ActionCreator'

import { Calendar, Incident, Mail } from 'components/lib/DesignSystem/Icons'

export const COMPANIES_REQUEST_ASYNC = createAsyncTypes(
  'COMPANIES_REQUEST',
  'ResolutionCenter/TopBar'
)

export const SEARCH_CHANGE = 'ResolutionCenter/TopBar/SEARCH_CHANGE'
export const SEARCH_RESET = 'ResolutionCenter/TopBar/SEARCH_RESET'

export const SORTING_FILTER_CHANGE = 'ResolutionCenter/TopBar/SORTING_FILTER_CHANGE'
export const SORTING_FILTER_RESET = 'ResolutionCenter/TopBar/SORTING_FILTER_RESET'
export const GENERAL_FILTER_CHANGE = 'ResolutionCenter/TopBar/GENERAL_FILTER_CHANGE'
export const CHALLENGED_TYPE_FILTER_CHANGE = 'ResolutionCenter/TopBar/CHALLENGED_TYPE_FILTER_CHANGE'

export const SORTING_OPTIONS = [
  {
    value: 'date',
    label: 'Creation Date',
    Icon: Calendar,
    id: 'CreationDate',
  },
  {
    value: 'latest_email_date',
    label: 'Last Message Sent',
    Icon: Incident,
    id: 'LastEmailAdded',
  },
  {
    value: 'priority',
    label: 'Priority',
    Icon: Mail,
    id: 'Priority',
  },
]

export const DEFAULT_SORTING_OPTION = {
  unclassifiedSortingBy: 'priority',
  classifiedSortingBy: 'date',
}
export const getLocalStorageIncidentsSortingKey = (urlState) =>
  urlState === 'classified' ? 'classifiedSortingBy' : 'unclassifiedSortingBy'
